import React, { useState, useEffect, createContext, useContext } from 'react';
import { get } from 'utils/request';
import Header from 'components/Header';
import Menu from 'elements/Menu';
import Router from 'Router';
import { sessionStorage, getFileContent } from 'utils/utils';
import './App.less';

const HomeContext = createContext([]);
const currentContext = createContext({});

function App() {
  const [homeData, setHomeData] = useState([]);
  const [currentData, setCurrentData] = useState({});
  
  useEffect(() => {
    get('/v2/home')
    .then(data => {
        if (data.code === 0 && data.res && data.res.length > 0) {
          const curSiteName = sessionStorage.get('siteName');
          const curSite = curSiteName ? data.res.find(item=>item.name === curSiteName) : null;
          const nextSite = curSite || data.res[0];

          setCurrentData(nextSite);
          sessionStorage.set('siteName', nextSite.name);
          setHomeData(data.res);
        }
    })
  }, [])

  if (homeData.length === 0 || Object.keys(currentData).length === 0) {
    return <LoadingAppShell />;
  }
  
  return (
    <div className="App">
      <HomeContext.Provider value={{
        homeData
      }}>
          <currentContext.Provider value={currentData}>
            <Header />
            <div className="main">
                <Router />
            </div>
            {/* <div className="contact-box">
              <Contact />
            </div> */}
            <Menu type="bottom"/>
            <Footer />
          </currentContext.Provider>
      </HomeContext.Provider>    
    </div>
  );
}

function LoadingAppShell() {
  const cas = getCasFromLocation();
  const name = getPrerenderProductName();

  return (
    <div className="App app-shell">
      <HeaderShell />
      <div className="main">
        {cas ? <ProductDetailShell name={name} cas={cas} /> : <div className="page-loading-shell" />}
      </div>
    </div>
  );
}

function HeaderShell() {
  return (
    <div className="Header header-shell">
      <div className="head-container">
        <div className="head">
          <span className="shell-line shell-head-line">&nbsp;</span>
          <div className="language"><span className="shell-line shell-lang-line">&nbsp;</span></div>
        </div>
      </div>
      <div className="top-container">
        <div className="top">
          <div className="header-shell-logo">J&amp;H CHEM</div>
          <div className="search header-shell-search" />
        </div>
      </div>
      <div className="Menu header-shell-menu">
        <ul>
          <li><span className="menu-title">Home</span></li>
          <li><span className="menu-title">Specials Offers</span></li>
          <li><span className="menu-title">Product</span></li>
          <li><span className="menu-title">Contact Us</span></li>
          <li><span className="menu-title">News</span></li>
        </ul>
      </div>
    </div>
  );
}

function ProductDetailShell({ name, cas }) {
  const title = name || <>J&amp;H <span>Product</span></>;

  return (
    <div className="ProductsDetail product-detail-shell">
      <h1 className="product-title">{title}</h1>
      <p className="cas-registry">CAS Registry Number: {cas}</p>
      <div className="product-detail">
        <div className="attrs">
          <p className="attrs-title">Product Name:{name}</p>
          <p className="attr"><span className="attr-name">Cas No.: </span>{cas}</p>
          <p className="attr shell-row">&nbsp;</p>
          <p className="attr shell-row">&nbsp;</p>
        </div>
        <div className="img-box"><div className="product-img-placeholder" /></div>
      </div>
      <div className="product-detail">
        <div className="attrs desc-attrs">
          <p className="attrs-title desc-title">Product Details</p>
          <p className="attr attr-bg shell-row">&nbsp;</p>
          <p className="attr shell-row">&nbsp;</p>
          <p className="attr attr-bg shell-row">&nbsp;</p>
        </div>
      </div>
      <div className="inquiries-box inquiries-shell"><h1>Inquiry</h1></div>
    </div>
  );
}

function getCasFromLocation() {
  if (typeof window === 'undefined') {
    return '';
  }
  const match = window.location.pathname.match(/^\/cas\/([^/]+)\/?$/);
  return match ? decodeURIComponent(match[1]) : '';
}

function getPrerenderProductName() {
  if (typeof document === 'undefined') {
    return '';
  }
  const h1 = document.querySelector('.cas-prerender h1, .product-detail-shell .product-title');
  return h1 ? h1.textContent : '';
}

function Footer() {
    const { copyright } = useContext(currentContext);
    const [copyrightContent,setCopyrightContent] = useState('')
    useEffect(() => {
      getFileContent(copyright).then((res)=>{
        if(res.res){
          setCopyrightContent(res.res.content)
        }
      }) 
    }, [copyright])
    return (
  
        <div className="Footer" dangerouslySetInnerHTML={{__html:copyrightContent+'<span><a href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/index">浙ICP备12045108号</a></span>'}}></div>
        
        );
}

export { HomeContext, currentContext };
export default App;
